import { Card, CardContent } from "@/components/ui/card";
import { Heart, Clock, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const losses = [
  {
    icon: Heart,
    iconColor: "text-accent",
    title: "I ricordi",
    description: "Quando una persona cara ci lascia, le sue storie, la sua saggezza e la sua esperienza svaniscono con lei.",
  },
  {
    icon: Clock,
    iconColor: "text-terracotta",
    title: "Le intonazioni, le pause, le reazioni",
    description: "Come una persona parla, ride, tace — dettagli vivi che non possono essere raccontati.",
  },
  {
    icon: Sparkles,
    iconColor: "text-sage-deep",
    title: "Ciò che si può solo vivere",
    description: "L'atmosfera unica della comunicazione con una persona, che non può essere espressa a parole.",
  },
];

export const WhatWeLose = () => {
  return (
    <section className="py-24 lg:py-32 bg-gradient-hero">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 lg:mb-20"
        >
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            Cosa perdiamo ogni giorno
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {losses.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.12 }}
            >
              <Card className="bg-card border-border/40 shadow-card hover:shadow-medium transition-shadow duration-500 h-full text-center">
                <CardContent className="p-8 lg:p-10 flex flex-col items-center h-full">
                  <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center mb-6">
                    <item.icon className={`w-5 h-5 ${item.iconColor}`} />
                  </div>
                  <h3 className="font-serif text-xl font-semibold text-foreground mb-3">{item.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
